// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T__R","left":"styles_left__16v5x"};